<p-dialog [visible]="visible"
          (onHide)="onHide()"
          [modal]="true"
          [closable]="false"
          [draggable]="false"
          [resizable]="false"
          [styleClass]="'cvx-chevron-confirm-dialog'"
          [styleClass]="'chevron-confirm-80vw'">
  <div class="popup-title">{{ title }}</div>
  <div class="popup-message">{{ message }}</div>
  <div class="popup-meta" *ngIf="lastModifiedBy">
    Last modified by: <strong>{{ lastModifiedBy }}</strong>
    <span *ngIf="lastModifiedAtUtc"> at {{ lastModifiedAtUtc | date:'yyyy-MM-dd HH:mm' }} UTC</span>
  </div>

  <div class="diffs" *ngIf="!loadingBaseline && diffs.length">
    <table class="diffs-table">
      <thead>
        <tr>
          <th>Input</th>
          <th>Previous official</th>
          <th>Your new value</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let d of diffs">
          <td>{{ d.name }}</td>
          <td>{{ d.oldValue | number:'1.0-2' }}</td>
          <td>{{ d.newValue | number:'1.0-2' }}</td>
        </tr>
      </tbody>
    </table>
  </div>
  <div class="loading" *ngIf="loadingBaseline">Loading baseline...</div>
  <div class="no-diffs" *ngIf="!loadingBaseline && (!diffs || diffs.length===0)">No effective value changes detected to save.</div>

  <div class="audit" *ngIf="auditTrail.length">
    <div class="audit-title">Previous modifications for this run date</div>
    <p-table [value]="auditTrail" [paginator]="true" [rows]="5" [rowsPerPageOptions]="[5,10,20]" class="audit-table">
      <ng-template pTemplate="header">
        <tr>
          <th>User</th>
          <th>Update date</th>
          <th>Input</th>
          <th>Old</th>
          <th>New</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-row>
        <tr>
          <td>{{ row.user }}</td>
          <td>{{ row.occurredAtUtc | date:'yyyy-MM-dd' }}</td>
          <td>{{ row.uiName || ('#' + row.inputId) }}</td>
          <td>{{ row.oldValue }}</td>
          <td>{{ row.newValue }}</td>
        </tr>
      </ng-template>
    </p-table>
  </div>

  <div class="footer-actions">
    <button class="confirm-btn confirm-btn-outlined" type="button" (click)="onCancel()">Cancel</button>
    <button class="confirm-btn confirm-btn-solid" type="button" [disabled]="saving || loadingBaseline || preparing" (click)="onAccept()">
      <span class="spinner" *ngIf="saving || loadingBaseline || preparing"></span>
      <span>Confirm</span>
    </button>
  </div>
</p-dialog>
